import { createApp } from 'vue';
import AOS from 'aos';
import App from './App.vue';
import BootstrapVue3 from 'bootstrap-vue-3';
import i18n from './i18n';
import Maska from 'maska';
import router from './router';
import store from './state/store';
import vClickOutside from 'click-outside-vue3';
import VueApexCharts from 'vue3-apexcharts';
import VueFeather from 'vue-feather';
import * as Sentry from '@sentry/vue';

import 'aos/dist/aos.css';
import '@/assets/scss/config/corporate/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);

AOS.init({
  easing: 'ease-out-back',
  duration: 1000,
});

const app = createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVue3)
  .component(VueFeather.type, VueFeather)
  .use(Maska)
  .use(i18n)
  .use(vClickOutside);

Sentry.init({
  app,
  dsn: 'https://fbfb431c9a1df8336e026b88d0a2e1db@o4509486425178112.ingest.us.sentry.io/4509486429896704',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

app.mount('#app');
